var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"900px","height":"1000px"},attrs:{"id":"pie"}})}
var staticRenderFns = []

export { render, staticRenderFns }